import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    responsiveContainerContainer: { flex: 1, overflow: 'hidden' },
    primaryText: { paddingRight: theme.spacing(0.5) },
    divider: {
      margin: theme.spacing(0.5, 0),
    },
    miniTableAttribute: {
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
    },
    miniTableRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    miniTableValue: {
      fontSize: '0.875rem',
      whiteSpace: 'nowrap',
    },
  };
};
